import {
  Box,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { ReactComponent as CheckedIcon } from "../../../assets/icons/tick.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import { useEffect, useState } from "react";
import filterContent from "./staticContent/filter.content";

export default function FilterCheckbox({
  onSetNewFilter,
  onRemoveFilter,
  filters,
  groupType,
  filterList,
}) {
  const [state, setState] = useState(filterList);
  const [type, setType] = useState(groupType);
  const [values, setValues] = useState([]);

  useEffect(() => {
    setType(groupType);
    var newState = {
      ...filterList,
    };
    setState(newState);
    setValues(() => [...filters[groupType]]);
  }, [filterList, groupType]);

  const handleChange = (event) => {
    if (event.target.checked) {
      setValues((prev) => [...prev, event.target.name]);
      onSetNewFilter(type, event.target.name);
    } else {
      const removedArray = values.filter((item) => item !== event.target.name);
      setValues((prev) => [...removedArray]);
      onRemoveFilter(type, event.target.name);
    }
  };
  return (
    <>
      <FormGroup
        sx={{
          mt: "15px",
          display: "block",
        }}
      >
        {Object.keys(state).map((keyName, index) => (
          <FormControlLabel
            key={index}
            label={
              <Typography
                variant="body1"
                sx={{
                  pl: "3px",
                  color: "grey.11",
                  fontSize: "12px",
                  display: "inline",
                }}
              >
                {filterContent[keyName]}
              </Typography>
            }
            sx={{
              p: "3px",
              mb: "5px",
              ml: 0,
              mr: "5px",
              color: "grey.11",
              borderRadius: "8px",
              borderWidth: "1px",
              display: "inline-flex",
              border: (theme) =>
                values.includes(keyName)
                  ? `1px solid ${theme.palette.secondary.main}`
                  : `1px solid ${theme.palette.grey[10]}`,
            }}
            labelPlacement="start"
            control={
              <Checkbox
                onChange={handleChange}
                name={keyName}
                checked={values.includes(keyName)}
                icon={<PlusIcon width={10} height={10} />}
                checkedIcon={<CheckedIcon width={13} height={10} />}
                sx={{
                  fontSize: "12px",
                  color: "grey.11",
                  "&.Mui-checked": {
                    color: "grey.11",
                  },
                }}
              />
            }
          />
        ))}
      </FormGroup>
    </>
  );
}
